import { environment } from '@environments/environment';

export class Logger {
    static log(message: string, ...args: any[]): void {
        if (!environment.production) {
            console.log(message, ...args); // eslint-disable-line no-console
        }
    }

    static warn(message: string, ...args: any[]): void {
        if (!environment.production) {
            console.warn(message, ...args); // eslint-disable-line no-console
        }
    }

    static error(message: string, ...args: any[]): void {
        if (!environment.production) {
            console.error(message, ...args); // eslint-disable-line no-console
        }
    }
}
